import { up } from 'styled-breakpoints';
import { css } from 'styled-components';

const mapToBreakpoints = (values, map) => {
    const returnValues = [];
    if (values === null || typeof values !== 'object') {
        return map(values);
    }
    for (const key of Object.keys(values)) {
        returnValues.push(css `
      ${up(key)} {
        ${map(values[key])}
      }
    `);
    }
    return returnValues;
};

export { mapToBreakpoints };
//# sourceMappingURL=mapToBreakpoints.js.map
